/**
 * The table panel type and the columns block it draws from.
 */
import { ANALYTICS_COLUMN_TYPES, normalizeAnalyticsColumnType } from '../../../cirra/analyticsColumnTypes.js';

const columns = {
  names: [{ id: 'table', label: 'Table', phrase: 'a table', guide: 'table.md', advanced: true, promptSummary: 'rows and columns' }],
  block: 'columns',
  /* The gestures this renderer FIRES (analyticsPanelEvents.js). Declared per type because an event
     a renderer never fires is a wiring that silently does nothing — so a type claims one only once
     its renderer calls the action hook. */
  events: ['rowClick'],
  /* Any type may carry columns, so this spec is not the last word on what a stored columns block
     holds: the visual editor writes a `mode` the agent never sends. The surfaces that walk one
     block per type leave this one out and reach for it by name instead. */
  sharedBlock: true,
  /* Displayed columns. `keys` is a full replacement list, so an empty one means "no custom columns"
     rather than no opinion — hence not required.

     The type vocabulary comes from shared/cirra so this writer and cirra's columns editor validate
     against the same list: the tool only ever sends "html", but the reconciler infers date/number/
     list types, and a writer holding a narrower private list silently destroys the ones it does not
     recognize. A type outside the shared vocabulary keeps whatever is stored, like any other enum. */
  fields: {
    keys: { kind: 'list', keyField: 'key', item: { type: { kind: 'enum', values: ANALYTICS_COLUMN_TYPES, normalize: normalizeAnalyticsColumnType } } }
  }
};

export default columns;
